import {
  FieldNames,
  constructErrorInlineText,
  constructFieldErrors,
  getIsEditMode,
} from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useErrorValidationContext } from 'modules/templateEditor/context/ErrorValidationContext';
import { useQueryParamContext } from 'modules/templateEditor/context/QueryParamContext';

export const useValidateContentField = (fieldName: FieldNames) => {
  const { view } = useQueryParamContext();
  const { isEditMode } = useEditableFieldsContext();
  const isEditModeVisible = getIsEditMode(view, isEditMode);

  const { localeContentErrors, localeContentWarnings } = useErrorValidationContext();

  const { hasError, hasWarning } = constructFieldErrors({
    contentErrors: localeContentErrors,
    contentWarnings: localeContentWarnings,
    fieldName,
  });

  const errorText = constructErrorInlineText({ condition: isEditModeVisible, hasError });

  return { hasError, hasWarning, errorText, localeContentErrors, localeContentWarnings };
};
